import { infiniteQueryOptions } from '@tanstack/vue-query'
import { getChats } from '../api/get-chats'

export const PERSONAL_CHATS_QUERY_KEY = ['chats', 'personal'] as const

export const personalChatsQueryOptions = infiniteQueryOptions({
  queryKey: PERSONAL_CHATS_QUERY_KEY,
  queryFn: ({ pageParam }) => getChats('personal', { after: pageParam }),
  initialPageParam: undefined as string | undefined,
  getNextPageParam: lastPage => lastPage.endCursor?.toString(),
  staleTime: 60_000,
})
